export default __webpack_public_path__ + "static/media/category_7.f6b74df3.png";